
import { Component, Prop, Vue } from 'vue-property-decorator';

import { Receipt } from '@/models';

@Component
export default class ReceiptModal extends Vue {
	@Prop()
	public receipt!: Receipt;

	public get receiptHtml(): string {
		return this.receipt.receipt.reduce((html: string, line: any[]) => {
			line[0] = String(line[0]) || '';
			line[1] = String(line[1]) || '';

			const classes = line[0]
				.trim()
				.split(' ')
				.reduce((lineClasses: string, item: string) => {
					switch (item) {
						case 'center':
							lineClasses += ' text-center';
							break;
						case 'bold':
							lineClasses += ' font-bold';
							break;
					}

					return lineClasses;
				}, '');

			if (classes) {
				html += `<li class="${classes.trim()}">${line[1]}</li>`;
			} else if (!line[0] && !line[1]) {
				html += `<li class="mb-4">${line[1]}</li>`;
			} else {
				html += `<li class="flex item-center justify-between">
					<span><pre>${line[0]}</pre></span>
					<span><pre>${line[1]}</pre></span>
				</li>`;
			}

			return html;
		}, '');
	}
}
